module.exports = __webpack_public_path__ + "static/media/Night_Market.2edcaaa1.png";